import { network } from '@utils'
import { QueryFunction } from './root'

interface BusinessPageVisitProps {
  slug: string
}

export const trackBusinessPageVisit: QueryFunction<BusinessPageVisitProps, void> = async ({
  slug
}) => {
  const url = `/v1/visit/business/${slug}/`
  await network.httpClient.request({
    url,
    method: 'GET'
  })
}
